// extracted by mini-css-extract-plugin
export default {"header":"homepage_header__D6jwa","fadeIn":"homepage_fadeIn__VCK+R"};